"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var small = "(a|an|and|as|at|but|by|en|for|if|in|of|on|or|nor|so|yet|the|to|v[.]?|via|vs[.]?)";
var punct = "([!\"#$%&'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]*)";

function lower(word) {
  return word.toLowerCase();
}

function upper(word) {
  return word.substr(0, 1).toUpperCase() + word.substr(1);
}

var titleCaps = function titleCaps(title) {
  if (!title) return "";
  var parts = [];
  var split = /[:.;?!] |(?: |^)["Ò]/g;
  var index = 0; // eslint-disable-next-line no-constant-condition

  while (true) {
    var m = split.exec(title);
    parts.push(title.substring(index, m ? m.index : title.length).replace(/\b([A-Za-z][a-z.'Õ]*)\b/g, function (all) {
      return /[A-Za-z]\.[A-Za-z]/.test(all) ? all : upper(all);
    }).replace(RegExp("\\b" + small + "\\b", "ig"), lower).replace(RegExp("^" + punct + small + "\\b", "ig"), function (all, punctuation, word) {
      return punctuation + upper(word);
    }).replace(RegExp("\\b" + small + punct + "$", "ig"), upper));
    index = split.lastIndex;
    if (m) parts.push(m[0]);else break;
  }

  return parts.join("").replace(/ V(s?)\. /gi, " v$1. ").replace(/(['Õ])S\b/gi, "$1s").replace(/\b(AT&T|Q&A)\b/gi, function (all) {
    return all.toUpperCase();
  });
};

var _default = titleCaps;
exports["default"] = _default;